import {
  Backdrop,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import Loader from "../../../components/Loader";
import React, { useReducer, useState } from "react";
import { toast } from "react-toastify";
import { common_axios } from "../../../App";
import { useFormik } from "formik";
import * as yup from "yup";
import FormList from "antd/lib/form/FormList";

const initialTodos = {
  disticts: [],
  selectedDisticts: null,
  visible: {
    disticts: false,
    division: false,
  },
  division: [],
  selectedDivision: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_DISTICTS":
      return { ...state, disticts: action.payload };
    case "SET_DISTICTS_SELECTED":
      return { ...state, selectedDisticts: action.payload };
    case "SET_DISTICTS_VISIBLE":
      return {
        ...state,
        visible: {
          ...state.visible,
          disticts: action.payload,
          division: false,
        },
      };
    case "SET_DIVISION":
      return { ...state, division: action.payload };
    case "SET_DIVISION_SELECTED":
      return { ...state, selectedDivision: action.payload };
    case "SET_DIVISION_VISIBLE":
      return {
        ...state,
        visible: {
          ...state.visible,
          division: action.payload,
          disticts: false,
        },
      };
    default:
      return state;
  }
};

function TargetNumber() {
  const [open, setOpen] = useState(false);
  const [distict, setDistict] = useState(null);
  const [disticts, setDisticts] = useState([]);
  const [division, setDivision] = useState([]);
  const [divisions, setDivisios] = useState(null);
  const [location, setLocation] = useState(null);

  const [state, dispatch] = useReducer(reducer, initialTodos);

  const fetchDropdown = async (type) => {
    try {
      setOpen(true);

      if (type == "disticts" || type == "Wdisticts") {
        const res = await common_axios(
          `${process.env.REACT_APP_COMMON_API}/details/district/all`
        );

        if (res.data.statusDescription.statusCode == 200) {
          // dispatch({ type: "SET_DISTICTS_VISIBLE", payload: true });
          // dispatch({ type: "SET_DISTICTS", payload: res.data.responseObject });
          setDisticts(res.data.responseObject);
          setOpen(false);
        } else {
          setOpen(false);
          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      } else if (type == "Division" || type == "WDivision") {
        const res = await common_axios(
          `${process.env.REACT_APP_COMMON_API}/details/division/All`
        );

        if (res.data.statusDescription.statusCode == 200) {
          // dispatch({ type: "SET_DIVISION_VISIBLE", payload: true });
          // dispatch({ type: "SET_DIVISION", payload: res.data.responseObject });
          setDivision(res.data.responseObject);
          setOpen(false);
        } else {
          setOpen(false);
          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  const validationSchema = yup.object({
    // workLocation: yup
    //   .string()
    //   .required("Work location is required")
    //   .nullable()
    //   .when("location", () => {
    //     if (location == "homeLocation") {
    //       return yup.string().nullable();
    //     }
    //   }),
    homeLocation: yup
      .string()
      .required("Home location is required")
      .nullable()
      .when("location", () => {
        if (location == "workLocation") {
          return yup.string().nullable();
        }
      }),
    // homeLocation: yup
    //   .string()
    //   .required("Home location  is required")
    //   .nullable(),
    // workLocation: yup.string().required("Work location is required").nullable(),
    roamingStatus: yup
      .string()
      .required("roaming Status is required")
      .nullable(),
    productClass: yup.string().required("product Class is required").nullable(),
    financialClass: yup
      .string()
      .required("financial Class is required")
      .nullable(),
    activityStatus: yup
      .string()
      .required("activity Status is required")
      .nullable(),
    voiceUsage: yup.string().required("voice Usage is required").nullable(),
    dataUsage: yup.string().required("data Usage is required").nullable(),
    targetBaseName: yup
      .string()
      .required("Target Base Name is required")
      .min(3, "Target Base Name must be at least 3 character")
      .nullable(),
    description: yup
      .string()
      .required("description is required")
      .min(3, "Target Base Name must be at least 3 character")
      .nullable(),
  });

  const formik = useFormik({
    initialValues: {
      homeLocation: null,

      distictDivsion: null,
      targetBaseName: "",
      description: "",
      productClass: "",
      roamingStatus: "",
      financialClass: "",
      activityStatus: "",
      voiceUsage: "",
      dataUsage: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(
          // `${process.env.REACT_APP_COMMON_API}/admin/v1/document/upload`,
          `${process.env.REACT_APP_COMMON_API}/master/user/criteria/create?=`,
          {
            criteria_name: values.targetBaseName,
            listOfdistrictid: [values.distictDivsion],
            listOfdivisionid: [values.distictDivsion],
            fromage: 15,
            gender: "m",
            prepost_type: 60,
            toage: 0,
            listOfunionid: [0, 1],
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          formik.handleReset();
          // res.data.senderIdModel.creationDate = await String(
          //   new Date(res.data.senderIdModel.creationDate)
          // );
          // await setData([...data, res.data.senderIdModel]);
          setOpen(false);

          await toast.success("Created Successfully", {
            theme: "colored",
          });
        } else {
          setOpen(false);

          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      } catch (error) {
        console.log(error);
        setOpen(false);

        await toast.error("Something went wrong", {
          theme: "colored",
        });
      }
    },

    validationSchema: validationSchema,
    enableReinitialize: true,
  });
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12 col-sm-8 mb-xl-0 mb-4">
              <div className="card mb-3 mt-4">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i className="material-icons opacity-10">person</i>
                  </div>
                  <p
                    className="text-sm mb-0 text-capitalize fw-bold"
                    style={{
                      marginLeft: "70px",
                    }}
                  >
                    Target Number
                  </p>
                  {/* <div className="text-end pt-1">
                    <p className="text-sm mb-0 text-capitalize fw-bold">
                      !! Field(s) marked with
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div> */}
                </div>
                <div className="card-body scroll">
                  <form
                    onSubmit={formik.handleSubmit}
                    className="text-start mt-5"
                  >
                    <div className="card shadow-none border mb-5 bg_blue card_1">
                      <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                        Geographical Targeting
                      </span>
                      <div className="card-body text-lg-start text-center">
                        <div className="row">
                          <div className="col-md-12">
                            {/* <div className="input-group input-group-outline pt-2">
                              <label
                                for="exampleFormControlSelect1"
                                className="ms-0 mb-0 d-inline-block"
                              >
                                Home Location
                                <span className="text-danger fw-bold">*</span>
                              </label>
                              <div className="form-check ps-0">
                                <input
                                  className="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label className="custom-control-label">
                                  Union
                                </label>
                              </div>
                              <div className="form-check ps-0">
                                <input
                                  onClick={() => {
                                    fetchDropdown("Division");
                                  }}
                                  className="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label className="custom-control-label">
                                  Division
                                </label>
                              </div>
                              <div className="form-check ps-0">
                                <input
                                  onClick={() => {
                                    fetchDropdown("disticts");
                                  }}
                                  className="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label className="custom-control-label">
                                  District/Thane
                                </label>
                              </div>
                              <div className="form-check ps-0">
                                <input
                                  className="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label className="custom-control-label">
                                  Site Code
                                </label>
                              </div>
                              <div className="form-check ps-0">
                                <input
                                  className="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label className="custom-control-label">
                                  None
                                </label>
                              </div>
                            </div> */}

                            <div className="input-group input-group-outline mb-3">
                              <TextField
                                required
                                className="w-100"
                                label="Target Base Name"
                                name="targetBaseName"
                                variant="outlined"
                                size="small"
                                type="text"
                                onBlur={formik.handleBlur}
                                value={formik.values.targetBaseName}
                                onChange={formik.handleChange}
                                error={
                                  formik.touched.targetBaseName &&
                                  Boolean(formik.errors.targetBaseName)
                                }
                                helperText={
                                  formik.touched.targetBaseName &&
                                  formik.errors.targetBaseName
                                }
                              />
                            </div>

                            <div className="input-group input-group-outline mb-3">
                              <TextareaAutosize
                                required
                                value={formik.values.description}
                                error={
                                  formik.touched.description &&
                                  Boolean(formik.errors.description)
                                }
                                helperText={
                                  formik.touched.description &&
                                  formik.errors.description
                                }
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                }}
                                name="description"
                                fullWidth
                                aria-label="minimum height"
                                minRows={5}
                                //   style={{ minHeight: "150px" }}
                                className={
                                  formik.errors.description
                                    ? "border-color-red w-100"
                                    : "w-100"
                                }
                                placeholder="description Here"
                              />
                              {formik.errors.description && (
                                <p
                                  className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained MuiFormHelperText-filled Mui-required css-k4qjio-MuiFormHelperText-root"
                                  style={{ color: "red" }}
                                >
                                  {formik.errors.description}
                                </p>
                              )}
                            </div>

                            <div className="input-group input-group-outline pt-2">
                              <FormControl
                                required
                                disabled={formik.values.workLocation != null}
                              >
                                {/* <label
                                  for="exampleFormControlSelect1"
                                  className="ms-0 mb-0 d-inline-block"
                                >
                                  Home Location
                                  <span className="text-danger fw-bold">*</span>
                                </label> */}
                                <RadioGroup
                                  value={formik.homeLocation}
                                  onChange={(e) => {
                                    setLocation("homeLocation");
                                    formik.handleChange(e);
                                  }}
                                  required
                                  row
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  name="homeLocation"
                                >
                                  <div>
                                    <label
                                      for="exampleFormControlSelect1"
                                      className="ms-0 mb-0 d-inline-block"
                                    >
                                      Home Location
                                      <span className="text-danger fw-bold">
                                        *
                                      </span>
                                    </label>
                                    <FormControlLabel
                                      value="Union"
                                      control={<Radio />}
                                      label="Union"
                                    />
                                    <FormControlLabel
                                      onClick={() => {
                                        fetchDropdown("Division");
                                      }}
                                      value="Division"
                                      control={<Radio />}
                                      label="Division"
                                    />
                                    <FormControlLabel
                                      onClick={() => {
                                        fetchDropdown("disticts");
                                      }}
                                      value="District/Thane"
                                      control={<Radio />}
                                      label="District/Thane"
                                    />
                                    <FormControlLabel
                                      value="Site"
                                      control={<Radio />}
                                      label="Site Code"
                                    />
                                    <FormControlLabel
                                      value="None"
                                      control={<Radio />}
                                      label="None"
                                    />
                                  </div>
                                  <div>
                                    <label
                                      for="exampleFormControlSelect1"
                                      className="ms-0 mb-0 d-inline-block"
                                    >
                                      Work Location
                                      <span className="text-danger fw-bold">
                                        *
                                      </span>
                                    </label>

                                    <FormControlLabel
                                      value="WUnion"
                                      control={<Radio />}
                                      label="Union"
                                    />
                                    <FormControlLabel
                                      onClick={() => {
                                        fetchDropdown("Division");
                                      }}
                                      value="WDivision"
                                      control={<Radio />}
                                      label="Division"
                                    />
                                    <FormControlLabel
                                      onClick={() => {
                                        fetchDropdown("disticts");
                                      }}
                                      value="WDistrict/Thane"
                                      control={<Radio />}
                                      label="District/Thane"
                                    />
                                    <FormControlLabel
                                      value="WSite"
                                      control={<Radio />}
                                      label="Site Code"
                                    />
                                    <FormControlLabel
                                      value="WNone"
                                      control={<Radio />}
                                      label="None"
                                    />
                                  </div>
                                </RadioGroup>
                              </FormControl>
                            </div>
                            {formik.errors.homeLocation && (
                              <p
                                className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained MuiFormHelperText-filled Mui-required css-k4qjio-MuiFormHelperText-root"
                                style={{ color: "red" }}
                              >
                                {formik.errors.homeLocation}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            {(formik.values.homeLocation == "District/Thane" ||
                              formik.values.homeLocation ==
                                "WDistrict/Thane") && (
                              <div className="input-group input-group-outline mb-3">
                                <FormControl fullWidth required>
                                  <InputLabel
                                    size="small"
                                    id="demo-simple-select-label"
                                  >
                                    District
                                  </InputLabel>
                                  <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="District"
                                    name="distictDivsion"
                                    value={formik.values.distictDivsion}
                                    onChange={formik.handleChange}
                                  >
                                    {disticts?.map((d) => {
                                      return (
                                        <MenuItem
                                          key={d.masterDistrictId}
                                          value={d.masterDistrictId}
                                        >
                                          {d.masterDistrictName}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                            )}

                            {(formik.values.homeLocation == "Division" ||
                              formik.values.homeLocation == "WDivision") && (
                              <div className="input-group input-group-outline mb-3">
                                <FormControl fullWidth required>
                                  <InputLabel
                                    size="small"
                                    id="demo-simple-select-label"
                                  >
                                    Division
                                  </InputLabel>
                                  <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Division"
                                    name="distictDivsion"
                                    value={formik.values.distictDivsion}
                                    onChange={formik.handleChange}
                                    // onChange={handleChange}
                                  >
                                    {division?.map((d) => {
                                      return (
                                        <MenuItem
                                          key={d.masterDivisionId}
                                          value={d.masterDivisionId}
                                        >
                                          {d.masterDivisionName}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                            )}

                            {/* <div className="input-group input-group-outline mb-3">
                              <TextField
                                required
                                className="w-100"
                                label="Customer Name"
                                name="customerName"
                                variant="outlined"
                                size="small"
                                type="text"
                                value={formik.values.customerName}
                                // onChange={formik.handleChange}
                                // error={
                                //   formik.touched.customerName &&
                                //   Boolean(formik.errors.customerName)
                                // }
                                // helperText={
                                //   formik.touched.customerName &&
                                //   formik.errors.customerName
                                // }
                              />
                            </div> */}
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-md-12">
                            <div className="input-group input-group-outline pt-2">
                              <FormControl
                                required
                                disabled={formik.values.homeLocation}
                              >
                                <label
                                  for="exampleFormControlSelect1"
                                  className="ms-0 mb-0 d-inline-block"
                                >
                                  Work Location
                                  <span className="text-danger fw-bold">*</span>
                                </label>
                                <RadioGroup
                                  value={formik.workLocation}
                                  onChange={(e) => {
                                    setLocation("workLocation");
                                    formik.handleChange(e);
                                  }}
                                  required
                                  row
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  name="workLocation"
                                >
                                  <FormControlLabel
                                    value="Union"
                                    control={<Radio />}
                                    label="Union"
                                  />
                                  <FormControlLabel
                                    value="Division"
                                    onClick={() => {
                                      fetchDropdown("Division");
                                    }}
                                    control={<Radio />}
                                    label="Division"
                                  />
                                  <FormControlLabel
                                    onClick={() => {
                                      fetchDropdown("disticts");
                                    }}
                                    value="District/Thane"
                                    control={<Radio />}
                                    label="District/Thane"
                                  />
                                  <FormControlLabel
                                    value="Site"
                                    control={<Radio />}
                                    label="Site Code"
                                  />
                                  <FormControlLabel
                                    value="None"
                                    control={<Radio />}
                                    label="None"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                            {formik.errors.workLocation && (
                              <p
                                className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained MuiFormHelperText-filled Mui-required css-k4qjio-MuiFormHelperText-root"
                                style={{ color: "red" }}
                              >
                                {formik.errors.workLocation}
                              </p>
                            )}
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-md-12">
                            <div className="input-group input-group-outline pt-2">
                              {formik.values.workLocation ==
                                "District/Thane" && (
                                <div className="input-group input-group-outline mb-3">
                                  <FormControl required fullWidth>
                                    <InputLabel
                                      size="small"
                                      id="demo-simple-select-label"
                                    >
                                      District
                                    </InputLabel>
                                    <Select
                                      size="small"
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="District"
                                      name="distictDivsion"
                                      value={formik.values.distictDivsion}
                                      onChange={formik.handleChange}
                                    >
                                      {disticts?.map((d) => {
                                        return (
                                          <MenuItem
                                            key={d.masterDistrictId}
                                            value={d.masterDistrictId}
                                          >
                                            {d.masterDistrictName}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </div>
                              )}

                              {formik.values.workLocation == "Division" && (
                                <div className="input-group input-group-outline mb-3">
                                  <FormControl required fullWidth>
                                    <InputLabel
                                      size="small"
                                      id="demo-simple-select-label"
                                    >
                                      Division
                                    </InputLabel>
                                    <Select
                                      size="small"
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Division"
                                      name="distictDivsion"
                                      value={formik.values.distictDivsion}
                                      onChange={formik.handleChange}
                                      // onChange={handleChange}
                                    >
                                      {division?.map((d) => {
                                        return (
                                          <MenuItem
                                            key={d.masterDivisionId}
                                            value={d.masterDivisionId}
                                          >
                                            {d.masterDivisionName}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card shadow-none border mb-5 bg_blue card_1">
                      <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                        Demographic Targeting
                      </span>
                      <div className="card-body text-lg-start text-center">
                        <div className="row">
                          {/* <div className="col-md-3">
                            <label className="form-label" for="customRange1">
                              Example range
                            </label>
                            <div className="range">
                              <input
                                type="range"
                                className="form-range"
                                id="customRange1"
                              />
                            </div>
                          </div> */}

                          <div className="col-md-4">
                            <div className="input-group input-group-outline mb-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  Product Class
                                </InputLabel>
                                <Select
                                  size="small"
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="Product Class"
                                  name="productClass"
                                  value={formik.values.productClass}
                                  onChange={formik.handleChange}
                                >
                                  {[
                                    {
                                      id: 1,
                                      name: null,
                                    },
                                    {
                                      id: 2,
                                      name: "Prepaid",
                                    },
                                    {
                                      id: 3,
                                      name: "Postpaid",
                                    },
                                  ]?.map((d) => {
                                    return (
                                      <MenuItem key={d.id} value={d.name}>
                                        {d.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              {/* <select
                                className="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Product Class</option>
                                <option>Prepaid</option>
                                <option>Postpaid</option>
                              </select> */}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-group input-group-outline mb-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  Roaming Status
                                </InputLabel>
                                <Select
                                  size="small"
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  name="roamingStatus"
                                  label="Roaming Status"
                                  value={formik.values.roamingStatus}
                                  onChange={formik.handleChange}
                                >
                                  {[
                                    {
                                      id: 1,
                                      name: null,
                                    },
                                    {
                                      id: 2,
                                      name: "Off",
                                    },
                                    {
                                      id: 3,
                                      name: "On",
                                    },
                                  ]?.map((d) => {
                                    return (
                                      <MenuItem key={d.id} value={d.name}>
                                        {d.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              {/* <select
                                className="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Roaming Status</option>
                                <option>Off</option>
                                <option>On</option>
                              </select> */}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-group input-group-outline mb-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  Financial Class
                                </InputLabel>
                                <Select
                                  size="small"
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  name="financialClass"
                                  label="Financial Class"
                                  value={formik.values.financialClass}
                                  onChange={formik.handleChange}
                                >
                                  {[
                                    {
                                      id: 1,
                                      name: null,
                                    },
                                    {
                                      id: 2,
                                      name: "Ultra",
                                    },
                                    {
                                      id: 3,
                                      name: "High",
                                    },
                                  ]?.map((d) => {
                                    return (
                                      <MenuItem key={d.id} value={d.name}>
                                        {d.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              {/* <select
                                className="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Financial Class</option>
                                <option>Ultra</option>
                                <option>High</option>
                              </select> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card shadow-none border mb-5 bg_blue card_1">
                      <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                        Behavioral Targeting
                      </span>
                      <div className="card-body text-lg-start text-center">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="input-group input-group-outline mb-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  Activity Status
                                </InputLabel>
                                <Select
                                  size="small"
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  name="activityStatus"
                                  label="Activity Status"
                                  value={formik.values.activityStatus}
                                  onChange={formik.handleChange}
                                >
                                  {[
                                    {
                                      id: 1,
                                      name: null,
                                    },
                                    {
                                      id: 2,
                                      name: "Active",
                                    },
                                    // {
                                    //   id: 3,
                                    //   name: "High",
                                    // },
                                  ]?.map((d) => {
                                    return (
                                      <MenuItem key={d.id} value={d.name}>
                                        {d.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>

                              {/* <select
                                className="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Activity Status</option>
                                <option>Active</option>
                              </select> */}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-group input-group-outline mb-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  Voice Usage
                                </InputLabel>
                                <Select
                                  size="small"
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  name="voiceUsage"
                                  label="Voice Usage"
                                  value={formik.values.voiceUsage}
                                  onChange={formik.handleChange}
                                >
                                  {[
                                    {
                                      id: 1,
                                      name: null,
                                    },
                                    {
                                      id: 2,
                                      name: "Ultra",
                                    },
                                    // {
                                    //   id: 3,
                                    //   name: "High",
                                    // },
                                  ]?.map((d) => {
                                    return (
                                      <MenuItem key={d.id} value={d.name}>
                                        {d.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              {/* <select
                                className="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Voice Usage</option>
                                <option>Ultra</option>
                              </select> */}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-group input-group-outline mb-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  Data Usage
                                </InputLabel>
                                <Select
                                  size="small"
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="Data Usage"
                                  name="dataUsage"
                                  value={formik.values.dataUsage}
                                  onChange={formik.handleChange}
                                >
                                  {[
                                    {
                                      id: 1,
                                      name: null,
                                    },
                                    {
                                      id: 2,
                                      name: "Ultra",
                                    },
                                    // {
                                    //   id: 3,
                                    //   name: "High",
                                    // },
                                  ]?.map((d) => {
                                    return (
                                      <MenuItem key={d.id} value={d.name}>
                                        {d.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              {/* <select
                                className="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Data Usage</option>
                                <option>Ultra</option>
                              </select> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="text-end">
                        <button
                          onClick={formik.handleReset}
                          className="btn btn-secondary mx-1"
                        >
                          Reset
                        </button>
                        <button type="submit" className="btn btn-primary mx-1">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-sm-4 mb-xl-0 mb-4">
              <div className="card mb-3 mt-4">
                {/* <div className="card-header p-3 pt-2"> */}
                {/* <div className="text-end pt-1">
                    <p className="text-sm mb-0 text-capitalize fw-bold">
                      Account Data Added, Please Provide Sender Masking Details
                      !! Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div> */}
                {/* </div> */}
                {/* <div className="card-body scroll">
                  <div className="row">
                    <div className="col-md-6 mt-2">
                      <span>Total Cost</span>
                    </div>
                    <div className="col-md-6">
                      <span>show</span>
                      <select
                        className="form-select form-select_filter  width_3"
                        aria-label="Default select example"
                      >
                        <option selected></option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </select>
                      <span>entries</span>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default TargetNumber;
